module.exports = __webpack_public_path__ + "img/400-886-3156.69e51e28.png";